import { AllieIconProps } from '../../../components';

export const CheckSquareSolidIcon: React.FC<AllieIconProps> = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="18" height="18" rx="3" fill="currentColor" />
    <path
      d="M4 9L7.5 12.5L14 6"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
